import Hero from "../components/home/Hero";
import About from "../components/home/About";
import Services from "../components/home/Services";
import Gallery from "../components/home/Gallery";
import CTA from "../components/home/CTA";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Gallery />
      <CTA />
    </>
  );
}
